export default __webpack_public_path__ + "static/media/Warlord's Greatsword.72b5e28f.jpg";